import { render, staticRenderFns } from "./OpenOrdersTony.vue?vue&type=template&id=36555dc3"
import script from "./OpenOrdersTony.vue?vue&type=script&lang=js"
export * from "./OpenOrdersTony.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports